<template>
  <form>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>business</md-icon>
        </div>
        <h4 class="title">
          Invoicing Details
          <span>
            <i class="fas fa-question-circle question-mark"></i>
            <md-tooltip md-direction="top"
              >This section contains your organization name and address which
              will appear on all invoices.</md-tooltip
            >
          </span>
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Organization Name</label>
              <md-input
                v-model="organization.name"
                v-on:input="emitDirty('name')"
                v-on:blur="validateOrg($v.organization.name)"
                data-tour="organization_name"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Address</label>
              <md-input
                v-model="organization.address.line1"
                v-on:input="emitDirty('address', 'line1')"
                type="text"
                data-tour="address_1"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Address 2</label>
              <md-input
                v-model="organization.address.line2"
                v-on:input="emitDirty('address', 'line2')"
                type="text"
                data-tour="address_2"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <div class="md-field md-theme-default md-has-value">
              <label>Country</label>
              <country-select
                v-model="organization.address.country"
                :country="organization.address.country"
                topCountry="CA"
                ref="country-select"
                v-on:input="
                  emitDirty('address', 'country');
                  validateOrg($v.organization.address.country);
                "
                data-tour="address_city"
                class="md-input"
              />
            </div>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <div class="md-field md-theme-default md-has-value">
              <label>State/Region</label>
              <region-select
                v-model="organization.address.state"
                :country="organization.address.country"
                :region="organization.address.state"
                :regionName="true"
                ref="region-select"
                v-on:input="emitDirty('address', 'state')"
                data-tour="address_state"
                class="md-input"
              />
            </div>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>City</label>
              <md-input
                v-model="organization.address.city"
                v-on:input="emitDirty('address', 'city')"
                data-tour="address_city"
                type="text"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Postal Code</label>
              <md-input
                v-model="organization.address.postalCode"
                v-on:input="emitDirty('address', 'postalCode')"
                v-on:blur="validateOrg($v.organization.address.postalCode)"
                type="text"
                data-tour="address_postalcode"
              ></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import _ from "lodash";
import validationRules from "../../validationRules";
export default {
  name: "edit-organization-form",
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    organization: {},
    ogOrganization: {},
    questionmark: {
      type: String,
      default: "./img/question_mark_64.png"
    },
    validationTrigger: {}
  },
  watch: {
    validationTrigger: function() {
      if (this.validationTrigger) {
        if (!this.validateOrg(this.$v.organization.name)) {
          if (!this.validateOrg(this.$v.organization.address.postalCode)) {
            this.validateOrg(this.$v.organization.address.country);
          }
        }
        this.$emit("validated");
      }
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    validateOrg: function(input) {
      input.$touch();
      if (
        input == this.$v.organization.name &&
        !this.$v.organization.name.required
      ) {
        this.$store.commit("pushError", "Organization name cannot be blank.");
        return true;
      } else if (
        !this.$v.organization.address.country.required ||
        this.$v.organization.address.country == ""
      ) {
        this.$store.commit("pushError", "Country is required.");
        return true;
      } else if (
        input == this.$v.organization.address.postalCode &&
        !this.$v.organization.address.postalCode.isValid
      ) {
        this.$store.commit(
          "pushError",
          "A valid US or Canadian postal code is required."
        );
        return true;
      }
      return false;
    },
    emitDirty: function(p, q) {
      if (q === "state") {
        // The region selector can race sometimes and cause the region to be empty
        var state = this.$refs["region-select"];
        if (
          this.organization.address.state == "" &&
          this.organization.address.state !=
            state.$el[state.$el.selectedIndex].text
        ) {
          setTimeout(() => {
            if (state.$el.selectedIndex > 0) {
              this.organization.address.state =
                state.$el[state.$el.selectedIndex].text;
            }
            this.emitDirty(p, q);
          }, 100);
        }
      }
      if (q === "country") {
        var country = this.$refs["country-select"];
        if (country && country.$el.selectedIndex > 0) {
          this.organization.address.countryFullName =
            country.$el[country.$el.selectedIndex].text;
        }
      }
      // Getting around Vue's weirdness with making values that were null into empty strings.
      if (p && q) {
        if (
          this.organization[p][q] === "" &&
          this.ogOrganization[p][q] === null
        ) {
          this.organization[p][q] = null;
        }
      } else if (
        this.organization[p] === "" &&
        this.ogOrganization[p] === null
      ) {
        this.organization[p] = null;
      }
      this.$emit(
        "dirty",
        "org-address",
        !_.isEqual(this.organization, this.ogOrganization)
      );
    }
  },
  validations() {
    return validationRules;
  }
};
</script>
<style>
.question-mark {
  height: 16px;
  width: 16px;
}

.question-mark img {
  width: 100%;
}

select.md-input {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA3klEQVRIS+3VMU9CMRTF8d8zBL+aizoQFhx0kUk33RzdYMNFXUFnYeGrYYyaJiUxJHDLSxodbNKpfeffc9/pbaPyaCrr+3OA++z4rtT5Pg5GuMnCY9yWQEoBE1xhlUUP8YDrCBIB0vojLvGO0yz4hm4JJAKcYYoPHGOZAUdYoIMBXrc5iQAHeMlzviFygj7O8dkWEJU4XI8chALRhn9AVKHf70VRTHu4wFfbmKZLNKt50dLBnna0imcMd/2I0phWa3Y/D1e1Xa9BCZJG0VuQNpaWKMx72xS1Fl5/WN3BN+AgJhnZQlq4AAAAAElFTkSuQmCC");
  background-position: calc(100% - 0.5rem), 100% 0;
  background-size: 1.5em 1.5em;
  background-repeat: no-repeat;
}
</style>
<style type="scss" scoped>
select {
  padding: 0 !important;
}
</style>
